<script lang="ts">
    import { createEventDispatcher, onDestroy, onMount } from "svelte";
    import { SPort } from "../script/store";
    import type { MesurmentEnv } from "../script/types";
    import Graph from "./Graph.svelte";
    import { formatRecValToDispForm, WikaParser } from "./dataParser";
    import SmallTable from "../wrapElement/SmallTable.svelte";
    import CheckBox from "../leafElement/CheckBox.svelte";
    import QrScanner from "../leafElement/QrScanner.svelte";
    import { registerTempretureLisener } from "../script/din/dataBroker";
    import { AppConfgiStore, DefAppConfig } from "../script/probeStore";
    import type { GraphData, ProbeData } from "./sub/types";
    import DataPointTaker from "./DataPointTaker.svelte";
    import { writable } from "svelte/store";

    // const DEF_MUSURMENT_TIMEOUT = 10_000;
    // const MESURED_TIMES = 10;
    const MIN_TO_MILISEC = 60_000;

    const dispatch = createEventDispatcher();
    let enabledGraphPreview = true;
    let controls: {
        clarAndInit: () => void;
        clearData: () => void;
        addEthanol: (name: any) => number;
        addProbe: (name: any) => number;
        pushVal: (serId: any, val: any, timestamp: any) => void;
        setMaxLength: (len: number) => void;
    };

    let AppConfig = DefAppConfig;
    AppConfgiStore.subscribe((appConf) => {
        AppConfig = appConf;
    });

    /* ================ ENV ============== */
    /*  export let enableEnvUpdate: boolean;
    export let env: MesurmentEnv; */
    let initComplete = false;
    let env: MesurmentEnv | null = null;
    let envObesrvableSubscription;
    export let envObesrvable;
    // export let envObesrvable: Writable<MesurmentEnv>;
    $: envObesrvableSubscription, subscribeToEnvObesrvable();

    function subscribeToEnvObesrvable() {
        if (!initComplete) return;
        if (envObesrvableSubscription) {
            envObesrvableSubscription();
        }
        envObesrvableSubscription = envObesrvable.subscribe(
            (enviroment: MesurmentEnv) => {
                if (!enviroment) return;
                console.log("ENV", enviroment);
                env = enviroment;
                updateEnv();
            }
        );
    }
    onMount(() => {
        initComplete = true;
        subscribeToEnvObesrvable();
    });

    let wikaDinData: GraphData;
    const wikaDataWriteable = writable<GraphData>(wikaDinData);
    let probeDinData: ProbeData[] = [];
    const probeDataWriteable = writable<ProbeData[]>(probeDinData);
    let tempretureSubscriptionList = [];
    function updateEnv() {
        controls.clarAndInit();
        controls.setMaxLength(AppConfig.graphEtanol.maxPointCount);
        const sensorId = controls.addEthanol("Etalon");
        // const now = new Date().getTime();
        wikaDinData = {
            last: [0, NaN],
            last_disp: [0, "--"],
            seriesId: sensorId,
            fullData: [],
        };
        console.log("[INFO - Using Env]:", env, wikaDinData);
        destroyTempretureSubscription();
        const dinData = [];
        env.group.merurmentList.forEach((mes) => {
            const probeId = mes.static.probe.id;
            const sensorId = controls.addProbe(probeId);
            const newData: ProbeData = {
                name: probeId,
                idKlt: mes.static.id,
                checked: false,
                last: [0, NaN],
                last_disp: [0, "--"],
                seriesId: sensorId,
                fullData: [],
                mes: mes,
            };
            dinData.push(newData);
            const subscriptionDestructor = registerTempretureLisener(
                probeId,
                ([time, temp]) => {
                    pushNewDataToComp();
                    pushNewDataToGraph(newData, temp, time);
                }
            );
            tempretureSubscriptionList.push(subscriptionDestructor);
        });
        probeDinData = dinData;
        start();
    }
    let probe_SL = [];
    const probeTimeUpdate = setInterval(() => {
        updateProbe_SL(probeDinData);
        pushNewDataToComp();
    }, 1000);
    $: {
        updateProbe_SL(probeDinData);
    }
    function updateProbe_SL(list) {
        probe_SL = list.map((val, i) => {
            const timeDiff = new Date().getTime() - val.last[0] + 1000; // round roof
            return {
                showHeadder: i == 0 ? true : false,
                row: [
                    {
                        title: "Id",
                        val: val.name,
                    },
                    {
                        title: "Kontrola",
                        type: "icon",
                        style: val.checked ? "prim" : "faded",
                        val: val.checked
                            ? `check_circle`
                            : "radio_button_unchecked",
                    },
                    {
                        title: "Před",
                        style:
                            timeDiff >
                            AppConfig.mesurmentParam.inactiveTimeToWarn *
                                1000 *
                                0.9
                                ? "warn"
                                : "",
                        val:
                            timeDiff > 1.5 * MIN_TO_MILISEC
                                ? `${Math.floor(timeDiff / MIN_TO_MILISEC)}m`
                                : `${Math.floor(timeDiff / 1000)}s`,
                    },
                    {
                        title: "Teplota",
                        val: `${
                            isNaN(val.last[1])
                                ? "        --  "
                                : val.last_disp[1]
                        }°C`,
                    },
                ],
            };
        });
    }

    /* ================ WIKA ============== */
    let wikaReadPort = "1";
    let Wika: WikaParser;
    let wikaReadEnable;
    $: wikaReadEnable = Boolean(Wika);
    const sPortSubscrition = SPort.subscribe((newPort) => {
        if (Wika) {
            Wika.clear();
            Wika = null;
        }
        if (!newPort) {
            stop();
            return;
        }
        Wika = new WikaParser(newPort, (newMsg) => {
            // console.log("Wika [IN]:", newMsg);
            if (newMsg && wikaDinData) {
                pushNewDataToGraph(
                    wikaDinData,
                    newMsg.val,
                    new Date().getTime()
                );
                pushWikaDataToComp();
            }
        });
        console.log("[INFO wika reader init]:");
        start();
    });

    function start() {
        if (Wika) {
            Wika.startRequestTimer([wikaReadPort]);
        }
    }
    function stop() {
        if (Wika) {
            Wika.stopRequestTimer();
        }
    }
    function pushNewDataToGraph(
        src: GraphData,
        newVal: number,
        newTime: number
    ) {
        const tup: [number, number] = [newTime, newVal];
        src.last_disp = [newTime, formatRecValToDispForm(newVal)];
        src.last = tup;
        src.fullData.push(tup);
        if (enabledGraphPreview) {
            controls.pushVal(src.seriesId, newVal, newTime);
        }
    }

    /* ================ SUB COMP ============== */

    function pushNewDataToComp() {
        probeDataWriteable.set(probeDinData);
        pushWikaDataToComp();
    }
    function pushWikaDataToComp() {
        // console.log('PUSH', wikaDinData, probeDinData);
        wikaDataWriteable.set(wikaDinData);
    }

    /* ================ OTHER ============== */
    let activeZoneWarn;
    function activeZoneAdd(param) {
        const dVal = param.detail;
        const probeToUpdate = probeDinData.filter(
            (probe) => probe.idKlt === dVal
        );
        probeToUpdate.forEach((probe) => {
            probe.checked = true;
        });
        probeDinData = [...probeDinData];
        if (probeToUpdate.length === 0 && activeZoneWarn) {
            activeZoneWarn();
        }
    }

    function destroyTempretureSubscription() {
        tempretureSubscriptionList.forEach((sub) => {
            sub();
        });
        tempretureSubscriptionList = [];
    }
    function cleanUp() {
        clearInterval(probeTimeUpdate);
        // stop();
        if (Wika) {
            Wika.clear();
        }
        destroyTempretureSubscription();
        sPortSubscrition();
        if (envObesrvableSubscription) {
            envObesrvableSubscription();
        }
    }
    onDestroy(cleanUp);
</script>

<div class="root">
    <!-- <div class="formDivider" style="padding-top: 4rem;">
        <p>Zdroje</p>
        <div />
    </div> -->
    <p class="bigText">Sensory (<strong>{probeDinData.length}</strong>)</p>
    <div class=" borderBox">
        <div class="controls">
            <QrScanner
                bind:showError={activeZoneWarn}
                on:code={activeZoneAdd}
                autoFocus={true}
            />
        </div>
        <div class="valTable">
            <p class="bigText">Aktuální teploty</p>
            {#if probe_SL.length == 0}
                <p class="smallWarning">Skupina neobsahuje žádné senzory</p>
            {/if}
            <SmallTable data={probe_SL} />
        </div>
    </div>

    <div class="bigText bigTextVithCheckBox">
        <p>Náhled</p>
        <div>
            <CheckBox bind:enable={enabledGraphPreview} />
        </div>
    </div>

    <Graph bind:controls />
    <div class="controls">
        <button
            disabled={!Boolean(controls)}
            class="standartButton"
            on:click={() => {
                controls.clearData();
            }}>Vyčistit graf</button
        >
    </div>
    {#if env}
        <DataPointTaker bind:env {wikaDataWriteable} {probeDataWriteable} on:newDT={(param) => {
            dispatch('newDT', param.detail);
        }} />
    {/if}
</div>

<style>
    .root {
        margin: 1rem 2rem;
    }
    .controls {
        display: flex;
        align-items: center;
    }
    .valTable {
        /* margin: 1rem 10%; */
        margin: 1rem 2.5rem;
    }
    .bigText {
        font-size: 1.4rem;
        padding: 0.5rem 0 0.5rem 0.7rem;
        font-weight: 300;
        color: var(--back_D2);
        user-select: all;
    }
    .bigTextVithCheckBox {
        display: flex;
        align-items: center;
    }
    .bigTextVithCheckBox > div {
        margin-left: 7px;
        font-size: 1rem;
        display: flex;
        align-items: center;
    }
    .smallWarning {
        margin: 1rem 5rem;
        color: var(--back_D18);
        font-weight: 300;
    }
</style>
